
import { useContext } from 'react';

import { Axis, Islands } from '@rta/rta-blueprint-library';

import { AppContext } from '@r-app/app-context';
import { renderTracking } from '@r-services/render-tracking';
import { showInlineIslands } from '../show/show-inline-islands';

export const DisplayInlineMode = (): React.ReactElement => {
	const { controller: { kitchen, navigation, options }} = useContext(AppContext);
	renderTracking.incrementRender('DisplayInline');

	const kitchenSize = kitchen.size;
	const island = kitchen.design.islands.findById(navigation.islandId) ?? null;
	const offsetY = navigation.panelId === null ? kitchenSize.depth : kitchenSize.origin.y;
	if (island === null) return <></>;

	return navigation !== null && kitchen.design.islands.length > 0
		? <g key={kitchen.id}
			transform-origin={'0 0'}
			transform={`
				rotate(0 0 0)
				translate(
					${-kitchenSize.origin.x},
					${offsetY})
			`}>
			{showInlineIslands({
				island,
				islands: kitchen.design.islands as Islands,
				rotation: island.axis as Axis,
				panel: island.panels.findById(navigation.panelId),
				kitchenSize,
				options
			})};
		</g>
		: <></>;
};
